<template>
    <div>
        <Banner/>
        <Notice :Notice='Notice'/>
        <News  :Newsname='News' :NewsNav='NewsNav' @Newslieb='Newslieb'/>
        <Business/>
        <Performance :Data='Cate' :http='http' :Banner='Banner1'/>
        <Course/>
        <Float :Data='floatdada'/>
        <Friendly-Links class="content"/>
    </div>
</template>

<script>
import Banner from '@/components/pc/Banner'
import Notice from '@/components/pc/Notice'
import News from '@/components/pc/News'
import Business from '@/components/pc/Business'
import Performance from '@/components/pc/Performance'
import Course from '@/components/pc/Course'
import FriendlyLinks from '@/components/pc/FriendlyLinks'
import Float from '@/components/pc/Float'
import{mapState} from'vuex';
export default {
    components:{
      Banner,
      Notice,
      News,
      Business,
      Performance,
      Course,
      FriendlyLinks,
      Float
    },
    data() {
        return {
            naml:{
                class_id:6,
                limit:6,
                page:1,
            },
            namltwo:{
                class_id:1,
                limit:5,
                page:1,
            },
        }
    },
    mounted() {
        //获取新闻
        this.$store.dispatch('PostNews',this.naml);
        this.Newslieb(1)
    },
    computed:{
        ...mapState({
            Cate:state=>state.share.Cate,
            Banner1:state=>state.share.Banner1,
            floatdada:state=>state.share.floatdada,
            Notice:state=>state.share.Notice,
            News:state=>state.share.News,
            NewsNav:state=>state.share.NewsNav,
            http:state=>state.share.Http
        })
    },
    methods: {
        Newslieb(id){
            this.namltwo.class_id=id
            this.$store.dispatch('PostNews',this.namltwo);
        }
    },
}
</script>

<style scoped>
        @media (max-width: 768px){
        .content{
            height: 280px !important;
            overflow: hidden;
        }
        }
</style>
